export enum Roles {
  DataCoordinator = 'Data Coordinator',
  GrantAdmin = 'Grant Admin',
  GrantUser = 'Grant User',
  ProjectOfficer = 'Project Officer',
  SystemSupportStaff = 'System Support Staff',
  SubrecipientUser = 'Subrecipient User',
}
